import ClipboardJS from 'clipboard';
import { initTooltip, showTooltip, hideTooltip, updateTooltipTitle } from './core/bootstrap-helpers.js';

window.ClipboardJS = ClipboardJS;

export function initClipboard() {
    if ($('.btn-copy').length) {
        initTooltip($('.btn-copy'), {
            trigger: 'click',
            placement: 'bottom',
        });

        function setTooltip(btn, message) {
            var $copyBtn = $(btn);
            updateTooltipTitle($copyBtn, message);
            hideTooltip($copyBtn);
            showTooltip($copyBtn);
        }

        function hideTooltipWithDelay(btn) {
            setTimeout(function () {
                hideTooltip(btn);
            }, 1000);
        }

        var clipboard = new ClipboardJS('.btn-copy');

        clipboard.on('success', function (e) {
            setTooltip(e.trigger, 'Copied!');
            hideTooltipWithDelay(e.trigger);
        });
    }
}
